class ImageGallery {
  getImageGallery(product: object): Array<object> {
    return (product['media_gallery'] || []).filter(
      i => i['type'] === 'image'
    ).sort(
      (a, b) => (a.position > b.position) ? 1 : -1
    );
  }

  getSingleImage(product: object, dimensions: string): string {
    try {
      return product['default_image']['dimensions'][dimensions] || '';
    } catch {
      return '';
    }
  }
  getImpressionImage(product: object, dimensions: string): string {
    try {
      return product['impression_image']['dimensions'][dimensions] || '';
    } catch {
      return '';
    }
  }
}

const imageGallery = new ImageGallery();

export {imageGallery};
